module.exports = __webpack_public_path__ + "img/envelope-open-solid.8669868.svg";